import React, { useState } from "react";
import TeamStyles from "./TeamStyles";
import CustomBreadcrumb from "../../global/components/CustomBreadcrumb/CustomBreadcrumb";
import { breadCrumbList } from "./TeamData";
import { Box, Grid, Typography } from "@mui/material";
import CustomPageHeader from "../../global/components/CustomPageHeader/CustomPageHeader";
import CustomTabs from "../../global/components/CustomTabs/CustomTabs";
import ShowAll from "./components/ShowAll/ShowAll";

interface CustomProps {
  setToggle: any;
  toggle: any;
}

const tabConfig = [
  {
    label: "Show All",
  },
  // {
  //   label: "Not Interested",
  // },
];

const Team = (props: CustomProps) => {
  const classes = TeamStyles;
  const [tabValue, setTabValue] = useState<string>("Show All");

  const handleChange = (newValue: string) => {
    setTabValue(newValue);
  };

  function getContent() {
    switch (tabValue) {
      case "Show All":
        return <ShowAll />;
      case "Not Interested":
        return <Typography>Not Interested</Typography>;
      default:
        return null;
    }
  }

  const getTeamPage = () => {
    return (
      <>
        {/* <CustomBreadcrumb breadCrumbList={breadCrumbList} /> */}
        <Box sx={classes.teamWrapper}>
          <CustomPageHeader
            heading="Leads Transfer"
            subInfo="View & manage all the leads your company is receiving."
          />

          <Grid container>
            {/* <Grid item xs={12}>
              <CustomTabs
                changeValue={handleChange}
                selected={tabValue}
                tabConfig={tabConfig}
              />
            </Grid> */}

            <Grid item xs={12}>
              {getContent()}
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };

  return getTeamPage();
};

export default Team;
